import { Percent } from "@silo/types";
import { asPercent, UtilizationState } from "@silo/utils";
import { cn } from "../../utils/class-names";
import { getUtilizationClassName } from "./utils";

interface BaseFutureProjectionsProps {
  totalApr1d: Percent;
  totalApr3d: Percent;
  utilizationState: UtilizationState;
}

export function BaseFutureProjections({
  totalApr1d,
  totalApr3d,
  utilizationState,
}: BaseFutureProjectionsProps): JSX.Element {
  return (
    <div
      className={cn(
        "flex flex-col items-end font-medium font-mono",
        getUtilizationClassName(utilizationState)
      )}
    >
      <span>
        {asPercent(totalApr1d)} <span className="text-shale-200">in 1d</span>
      </span>

      <span>
        {asPercent(totalApr3d)} <span className="text-shale-200">in 3d</span>
      </span>
    </div>
  );
}
